import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface LocationChangePromptBottomSheetProps {
  modalState: UseModalState;
  onUpdateAddress: () => void;
  onDismiss: () => void;
}

export function LocationChangePromptBottomSheet(props: LocationChangePromptBottomSheetProps) {
  const { modalState, onUpdateAddress, onDismiss } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={
        <BottomSheetHeader
          onClose={() => {
            onDismiss();
          }}
        />
      }
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
          <Button fullWidth variant="contained" size="large" onClick={onUpdateAddress}>
            Update My Address
          </Button>
          <Button fullWidth variant="outlined" size="large" onClick={onDismiss}>
            Not Now
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="location-error"
        title="You seem to be in a new area!"
        description="Update your address to see nearby shifts!"
      />
    </BottomSheet>
  );
}
